import isEmpty from 'lodash/isEmpty';
import { createSelector } from 'reselect';
import ExportRequestManager from '@Services/ExportRequestManager';
import { EXPORT_TYPES } from '@Services/ExportService/ExportConstants';
import { EXPORT_ERRORS, exportModalReducerKey, SELECT_DATA_EXPORT_OPTION } from './ExportModalConstants';

export function exportModal(state) {
  return state.get(exportModalReducerKey);
}

export function isLoading(state) {
  return exportModal(state).get('isLoading');
}

export function currentView(state) {
  return exportModal(state).get('currentView');
}

export function entries(state) {
  return exportModal(state).get('entries');
}

export function data(state) {
  return exportModal(state).get('data');
}

export function formData(state) {
  return exportModal(state).get('formData');
}

export function selectedDatapoints(state) {
  return exportModal(state).get('selectedDatapoints');
}

export function formatsBackup(state) {
  return exportModal(state).get('formatsBackup');
}

export function exportType(state) {
  return exportModal(state).get('exportType');
}

export function errors(state) {
  return exportModal(state).get('errors');
}

// eslint-disable-next-line no-shadow
export const isSelectionExportActive = createSelector([formData], (data) => {
  return data.export === SELECT_DATA_EXPORT_OPTION;
});

export const isBusy = createSelector([exportType], (type) => {
  return ExportRequestManager.isBusy(type);
});

export const isFormAcceptable = createSelector(
  [isSelectionExportActive, selectedDatapoints, errors, isBusy],
  // eslint-disable-next-line no-shadow
  (isActive, datapoints, errors, busy) => {
    const isDatapointsRequired = isActive && isEmpty(datapoints.ids);
    return !isDatapointsRequired && !errors[EXPORT_ERRORS.FORMAT] && !busy && !errors[EXPORT_ERRORS.FORM_ERROR];
  }
);

export const isResultsExport = createSelector([exportType], (type) => {
  return type === EXPORT_TYPES.GENERIC;
});

export const isChemQuoteExport = createSelector([exportType], (type) => {
  return type === EXPORT_TYPES.CHEMQUOTE;
});
